// Added by CTC 11-18-16

// PDP Development
	//only show / hide elements in development
$(document).ready(function() {
	console.log('CTC Development Environment');
    
    //show hide addClass
    $('.free-shipping-banner').hide();
    $('body').addClass('ctc'); /* why was this commented out? */
    $('html').css('padding-top','0');
    
    $('#ctc-mobile-hamburger').on('click',function() {
      console.log('nav clicked');
      	$('.mobile-navigation .navopen').click();
    }); 
  if(window.location.href.indexOf('ctcdev3')  > -1) {
    $('body').addClass('ctc3');
  } 
  
});